/* SK Wishlist — favoritos nativos del tema (localStorage), sin depender de apps.

   Botones: cualquier elemento con clase .sk-fav-btn y data-product-handle
   (+ data-variant-id, data-product-id opcionales para enlaces/render).
   Estado: localStorage 'sk_wishlist' = [{ h: handle, v: variantId, p: productId }].
   Contador header: cualquier elemento con [data-sk-wishlist-count]. */
(function () {
  'use strict';

  var KEY = 'sk_wishlist';

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* quota/privacy */ }
    document.dispatchEvent(new CustomEvent('sk:wishlist:change', {
      bubbles: true,
      detail: { count: list.length },
    }));
  }

  function indexOf(list, handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].h === handle) return i;
    }
    return -1;
  }

  function setBtnState(btn, saved) {
    btn.classList.toggle('is-wishlist', saved);
    btn.setAttribute('aria-pressed', String(saved));
  }

  function applyAll() {
    var list = read();
    document.querySelectorAll('.sk-fav-btn[data-product-handle]').forEach(function (btn) {
      setBtnState(btn, indexOf(list, btn.dataset.productHandle) !== -1);
    });
  }

  function updateCount(n) {
    document.querySelectorAll('[data-sk-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function pulse(btn) {
    btn.classList.remove('is-pulsing');
    requestAnimationFrame(function () { btn.classList.add('is-pulsing'); });
    setTimeout(function () { btn.classList.remove('is-pulsing'); }, 420);
  }

  function toggle(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;

    var list = read();
    var i = indexOf(list, handle);
    var saved;
    if (i === -1) {
      list.push({ h: handle, v: btn.dataset.variantId || '', p: btn.dataset.productId || '' });
      saved = true;
    } else {
      list.splice(i, 1);
      saved = false;
    }
    write(list);

    /* Sincronizar TODOS los botones del mismo producto (puede haber varios en la pagina) */
    var sel = '.sk-fav-btn[data-product-handle="' + handle.replace(/"/g, '\\"') + '"]';
    document.querySelectorAll(sel).forEach(function (b) {
      setBtnState(b, saved);
      pulse(b);
    });
    updateCount(list.length);
  }

  /* Click delegado: funciona en cualquier seccion, presente o cargada despues */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sk-fav-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  function init() {
    applyAll();
    updateCount(read().length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-aplicar tras render de secciones (editor / paginacion AJAX) */
  document.addEventListener('shopify:section:load', init);
  /* Mantener el contador sincronizado con cada cambio */
  document.addEventListener('sk:wishlist:change', function (e) {
    updateCount(e && e.detail ? e.detail.count : read().length);
  });
  /* Sync entre pestañas del mismo navegador */
  window.addEventListener('storage', function (e) { if (e.key === KEY) init(); });

  /* API publica para la pagina de favoritos */
  window.SKWishlist = {
    read: read,
    has: function (handle) { return indexOf(read(), handle) !== -1; },
    remove: function (handle) {
      var l = read();
      var i = indexOf(l, handle);
      if (i !== -1) { l.splice(i, 1); write(l); applyAll(); }
    },
  };
})();
